function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import useGiveawayStore from '@/stores/GiveawayStore';
import GiveawayActiveStep from './GiveawayActiveStep';
import GiveawayKeywordStep from './GiveawayKeywordStep';
import GiveawayRandomNumberStep from './GiveawayRandomNumberStep';
import { useShallow } from 'zustand/react/shallow';
import { GiveawayType } from '@/types/client';
export default function GiveawayCreateConditions(props) {
    var type = useGiveawayStore(useShallow(function(state) {
        return state.type;
    }));
    if (type === GiveawayType.RANDOM_NUMBER) {
        return /*#__PURE__*/ _jsx(GiveawayRandomNumberStep, _object_spread({}, props));
    } else if (type === GiveawayType.KEYWORD) {
        return /*#__PURE__*/ _jsx(GiveawayKeywordStep, _object_spread({}, props));
    } else if (type === GiveawayType.ACTIVE_USER) {
        return /*#__PURE__*/ _jsx(GiveawayActiveStep, _object_spread({}, props));
    } else {
        return null;
    }
}
